import React, { FC, useEffect, useRef, useState } from 'react';
import cs from 'classnames';
import { Button, Cascader, Col, Form, Row, Space } from 'antd';
import styles from './index.module.less';
import V2Drawer from '@/common/components/Feedback/V2Drawer';
import V2Title from '@/common/components/Feedback/V2Title';
import V2Form from '@/common/components/Form/V2Form';
import V2FormProvinceList from '@/common/components/Form/V2FormProvinceList';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
import CirclebusinessMap from 'src/common/components/business/ExpandStore/CircleBusinessMap/index';
import { isArray, isNotEmptyAny, refactorSelection } from '@lhb/func';
import { getCookie } from '@lhb/cache';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { createCircleTask, getStandardTaskSelection } from '@/common/api/expandStore/expansiontask';
import { useBigdataFn } from '@/common/utils/bigdata';
import { useSelector } from 'react-redux';
import { AssignType } from '@/common/components/business/ExpandStore/ts-config';
import { useMethods } from '@lhb/hook';
import { FollowingStatus } from 'src/views/expandstore/pages/expansioncirclesenmatask/ts-config';
import V2Container from '@/common/components/Data/V2Container';
import AssignResponsibleAccount from './AssignResponsibleAccount';
import { ResponsibleAccountType } from 'src/views/expandstore/pages/expansiontask/ts-config';

/**
 * 拓店任务-新增/编辑抽屉
 * @Description 拓店任务：森马（参考clusterA直营）
 */
const CircleTaskCreateDrawer: FC<{
  /** 是否显示抽屉 */
  showDrawer: boolean;
  /** 控制是否显示抽屉 */
  setShowDrawer: React.Dispatch<boolean>;
  /** 提交表单后的回调 */
  refresh?: ()=>void;
  businessInfo?:any;
  isBusiness?:boolean;
}> = ({
  showDrawer,
  setShowDrawer,
  isBusiness = false,
  businessInfo,
  refresh
}) => {

  const [innerMainHeight, setInnerMainHeight] = useState<number>(0);

  const [form] = Form.useForm();
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const circlebusinessMap: any = useRef();
  const [requesting, setRequesting] = useState(false);
  const [selection, setSelection] = useState<{
    /** 跟进状态 */
    followingStatusList: any[],
    /** 紧急程度 */
    emergencyOptions: any[],
   }>({ followingStatusList: [], emergencyOptions: [] });

  const targetAddressInfo = Form.useWatch('targetAddressInfo', form);
  const businessName = Form.useWatch('businessName', form);
  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  const isAssignTypeLeader = [AssignType.Twice, AssignType.ThreeTimes].includes(tenantCheckData?.taskAssignType); // 是否指派主管（二次、三次指派兼容为同样处理）
  /** 发起点位评估后，状态自动变更为「已立项」，此时禁用编辑状态 */
  const [followingStatusDisabled, setFollowingStatusDisabled] = useState(false);

  useEffect(() => {
    methods.getSelection();
    if (isBusiness) {
      const { id, areaName, provinceId, cityId, districtId, provinceName, cityName, districtName, emergencyDegree, followingStatus } = businessInfo;
      form.setFieldsValue({
        businessName: areaName,
        targetAddress: [provinceId, cityId, districtId],
        targetAddressInfo: [provinceName, cityName, districtName],
        circleBusinessId: id,
        emergencyDegree,
        followingStatus,
      });
      if (followingStatus === FollowingStatus.Launched) {
        setFollowingStatusDisabled(true);
      }
    }
  }, []);

  useEffect(() => {
    // const targetCity = targetAddressInfo && isArray(targetAddressInfo) ? `${targetAddressInfo.slice(0, 2).join('/')}_` : '';
    const targetCity = targetAddressInfo && isNotEmptyAny(targetAddressInfo[1]) ? `${targetAddressInfo[1]}_` : '';
    const targetBusinessName = businessName ? `${businessName}_` : '';

    const taskName = (targetCity || targetBusinessName) ? `${targetCity}${targetBusinessName}拓店任务` : '';
    form.setFieldsValue({
      name: taskName
    });
  }, [targetAddressInfo, businessName]);

  const methods = useMethods({

    /**
     * 获取下拉选项
     */
    getSelection: async () => {
      getStandardTaskSelection().then(res => {
        setSelection(val => ({ ...val,
          emergencyOptions: refactorSelection(res.emergencyDegree),
          // 产品要求过滤掉“已立项”选项，避免用户主动修改值
          followingStatusList: refactorSelection(res.followingStatusList).filter(item => item.value !== FollowingStatus.Launched)
        }));
      });
    },

    /**
     * 提交表单
     */
    onSubmit: async():Promise<void> => {
      const { radio, assignAccountIds, targetAddress, ...values } = await form.validateFields();
      const { managerId } = values;
      bigdataFn('ba1786de-ac00-484e-8566-ababe085a3c3', '创建拓店任务-点击确定', '点击了创建拓店任务-点击确定', { op_block: '创建拓店任务', op_event: ``, });
      let assignAccount: any[] = [];
      if (radio === ResponsibleAccountType.ASSIGN_SELF) {
        const accountId = getCookie('employeeId');
        assignAccount = [accountId];
      } else if (radio === ResponsibleAccountType.ASSIGN_OTHER) {
        if (isAssignTypeLeader) {
          if (!managerId) {
            V2Message.warning('请选择开发主管');
            return;
          }
        } else if (assignAccountIds) {
          assignAccount = [assignAccountIds];
        } else {
          V2Message.warning('请选择指派的团队成员');
          return;
        }
      } else {
        V2Message.warning('请选择指派的成员');
        return;
      }
      if (targetAddress && !targetAddress[1]) {
        V2Message.warning('城区请选择到市');
        return;
      }
      try {
        setRequesting(true);
        const {
          name,
          emergencyDegree,
          followingStatus,
        } = values;
        let emergencyTmp = emergencyDegree;
        // 如果是多级，取最后一级，否则使用当前值
        if (isArray(emergencyTmp)) {
          emergencyTmp = emergencyTmp.length ? emergencyTmp[emergencyTmp.length - 1] : null;
        }

        const circleBusinessId = form.getFieldValue('circleBusinessId');
        // 构建目标城市参数
        const targetAddNew = targetAddress && {
          targetProvinceId: targetAddress[0] || undefined,
          targetCityId: targetAddress[1] || undefined,
          targetDistrictId: targetAddress[2] || undefined,
        };
        const params: any = {
          name,
          emergencyDegree: emergencyTmp,
          followingStatus,
          // spotSurveyEmergencyDegree: isKwk ? values?.spotSurveyEmergencyDegree : null,
          // chancePointEmergencyDegree: isKwk ? values?.chancePointEmergencyDegree : null,
          ...targetAddNew,
          modelClusterId: circleBusinessId,
        };
        // 指派自己、或者指派其他成员时传assignAccountIds，指派主管用managerId
        Object.assign(params, radio === ResponsibleAccountType.ASSIGN_OTHER && isAssignTypeLeader ? { managerId } : {
          assignAccountIds: assignAccount,
        });
        createCircleTask(params).then(() => {
          V2Message.success('创建拓店任务成功');
          setShowDrawer(false);
          refresh && refresh();
        }).catch((err) => {
          setShowDrawer(false);
          console.log('catch 失败', err);
          V2Message.error('创建拓店任务失败');
        }).finally(() => {
          setRequesting(false);
        });
      } catch (error) {
        console.log('error', error);
        setShowDrawer(false);
        setRequesting(false);
      }
    },

    /**
     * 取消创建拓店任务
     */
    onCancel: () => {
      setShowDrawer(false);
      bigdataFn('ba1786de-ac00-484e-8566-ababe085a3c3', '创建拓店任务-点击取消', '点击了创建拓店任务-点击取消', { op_block: '创建拓店任务', op_event: ``, });
    },

  });

  return (
    <V2Drawer
      className={styles.createTaskDrawer}
      open={showDrawer}
      bodyStyle={{ padding: 0, }}
      onClose={() => setShowDrawer(false)}
      destroyOnClose
      // contentWrapperStyle={{
      //   minWidth: 'auto',
      //   width: '1008px',
      // }}
    >
      <V2Container
        emitMainHeight={(h) => setInnerMainHeight(h)}
        extraContent={{
          top: (<V2Title type='H1' text='创建拓店任务' className={styles.title} />),
          bottom: (<Space className={styles.bottom} size={12}>
            <Button type='default' onClick={methods.onCancel}>取消</Button>
            <Button type='primary' loading={requesting} onClick={methods.onSubmit}>确定</Button>
          </Space>)
        }}
        style={{ height: '100%', width: '100%' }}
        className={styles.container}>
        <V2Form form={form} className={cs('pt-16 pb-16 pl-40 pr-40', styles.editMain)} style={{ height: innerMainHeight }} >
          <V2Title type='H2' divider text='拓店任务信息' className={'mb-16'} />
          <Row gutter={24}>
            <Col span={24} className='mb-16'>
              <CirclebusinessMap form ={form} ref={circlebusinessMap} businessInfo={businessInfo} isBusiness={isBusiness} />
            </Col>
            <Col span={12}>
              <V2FormInput required label='商圈' name='businessName' disabled={true} placeholder='请在地图上选择商圈'/>
            </Col>
            <Col span={12}>
              <Form.Item name='targetAddressInfo' hidden noStyle/>
              <V2FormProvinceList
                required
                label='目标城市'
                name='targetAddress'
                disabled={true}
                config={{
                  value: [1],
                  changeOnSelect: true,
                  allowClear: true,
                  expandTrigger: 'hover',
                  showCheckedStrategy: Cascader.SHOW_PARENT,
                  onChange: (_, selectedOptions) => {
                    circlebusinessMap.current?.onChangeProvince && circlebusinessMap.current.onChangeProvince(_, selectedOptions);
                  },
                  onDropdownVisibleChange: (value) => {
                    circlebusinessMap.current?.onChangeProvince && circlebusinessMap.current.onDropdownVisibleChange(value);
                  }
                }}
              />
            </Col>
            <Col span={12}>
              <V2FormInput required label='拓店任务名称' name='name' maxLength={50} />
            </Col>
            <Col span={12}>
              <V2FormSelect required label='跟进状态' name='followingStatus' disabled={followingStatusDisabled} options={selection.followingStatusList} />
            </Col>
            <Col span={12}>
              <V2FormSelect required label='紧急度' name='emergencyDegree' options={selection.emergencyOptions} />
            </Col>
          </Row>
          <V2Title type='H2' divider text='选择拓店责任人' style={{ margin: '16px 0' }} />
          {/* 选择拓店责任人 */}
          <AssignResponsibleAccount form={form}/>
        </V2Form>
      </V2Container>
    </V2Drawer>
  );
};
export default CircleTaskCreateDrawer;
